import { assetUrl } from "@/lib/assets";
import { Link } from "@/components/common/Link";
import { useState } from "react";
const newsCards = [{
  image: assetUrl("Gayle-Lewis_1400.jpg"),
  heading: "ESTA SEMANA EN LA HISTORIA DE LAS AD — 13 DE AGOSTO DE 1972",
  body: "Durante dos décadas, Gayle F. Lewis ayudó a liderar las Asambleas de Dios como superintendente general adjunto, incluyendo el cumplimiento del mandato restante del superintendente general Wesley Steelberg, quien falleció en el cargo."
}, {
  image: assetUrl("Columbia-earthquake_1400.jpg"),
  heading: "TERREMOTO EN COLOMBIA, CRISIS DE AGUA EN PUERTO RICO: LAS AD Y CONVOY OF HOPE MOVILIZAN AYUDA",
  body: "Los obreros globales de las AD están a salvo en Colombia, y Misiones Mundiales de las AD junto a Convoy of Hope están brindando la ayuda tan necesitada a los sobrevivientes del terremoto y a un Puerto Rico afectado por la sequía."
}, {
  image: assetUrl("Colonel-Sanders_1400.jpg"),
  heading: "SERIE DE TRATADOS REVIVALTIME — EL CORONEL SANDERS COMIENZA UNA NUEVA VIDA",
  body: "Conocido en todo el mundo como \"Coronel Sanders\", Harland Sanders entregó su vida a Cristo en una iglesia de las Asambleas de Dios. C.M. Ward compartió más tarde el testimonio de Sanders en un tratado de Revivaltime."
}, {
  image: assetUrl("Reach-Church_1400.jpg"),
  heading: "REACH CHURCH TRANSFORMA EL ALCANCE COMUNITARIO EN OPORTUNIDADES PARA EL EVANGELIO",
  body: "Un evento comunitario gratuito de una iglesia de Iowa abrió las puertas para compartir el evangelio, resultando en decenas de salvaciones."
}, {
  image: assetUrl("Nancy-Warner-Tornado_1400.jpg"),
  heading: "A SALVO EN LAS MANOS DE DIOS",
  body: "Cuando Nancy Warner se encontró en medio de un tornado EF3, Dios respondió a sus desesperadas oraciones."
}, {
  image: assetUrl("FAF-discipleship_1400.jpg"),
  heading: "FORMANDO DISCÍPULOS A TRAVÉS DE LAS BELLAS ARTES",
  body: "La Conferencia Nacional de Jóvenes y el Festival de Bellas Artes concluyeron la semana pasada en St. Louis con momentos transformadores para estudiantes de todo el país."
}];
export default function FeaturedNews() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCount = 4;
  const prev = () => {
    setCurrentIndex(i => Math.max(0, i - 1));
  };
  const next = () => {
    setCurrentIndex(i => Math.min(newsCards.length - visibleCount, i + 1));
  };
  const canPrev = currentIndex > 0;
  const canNext = currentIndex < newsCards.length - visibleCount;
  // The recovered WVC source never rendered this unfinished carousel.
  // Keeping it as null preserves the current live page without a React error.
  return null;
}
